"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogbookIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const LogbookIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M5 5.73244C5.5978 5.38663 6 4.74028 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 4.74028 2.4022 5.38663 3 5.73244V20H5V5.73244Z", fillOpacity: "0.5", fillRule: "evenodd", clipRule: "evenodd" }),
    react_1.default.createElement("path", { d: "M15 6.79911C12.4201 5.50913 8.33333 6.0159 7 6.68257V11.6825V15.6825C8.5 15.0159 11 14.2991 14 15.6825C16.3259 16.7551 20.1667 16.3492 22 15.6825L20.5 11.5L22 6.68255L21.9697 6.69467C20.3051 7.36062 17.9819 8.29006 15 6.79911Z" })));
exports.LogbookIcon = LogbookIcon;
exports.default = exports.LogbookIcon;
